import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "../lib/api";
import { useApp } from "../context/AppContext";
import { PageHead } from "./Shop";

import { tx, useLang } from "../lib/i18n";
export function About() { const lang = useLang();
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/home").then((r) => setS(r.data.settings)).catch(() => setS({})); }, [lang]);
  return (
    <div className="mv-container max-w-3xl" data-testid="about-page">
      <PageHead eyebrow={tx("THE 4TH DIMENSION OF SHOPPING")} title={tx(s?.about_title || "About MIVO")} />
      <div className="space-y-4 text-[15px] leading-relaxed text-[var(--mv-muted)] whitespace-pre-line" data-testid="about-body">{tx(s?.about_body)}</div>
      <div className="mt-10 flex gap-3">
        <Link to="/shop" className="mv-btn-primary rounded-lg px-6 py-3 text-sm">{tx("Start shopping")}</Link>
        <Link to="/stores" className="mv-btn-outline rounded-lg px-6 py-3 text-sm">{tx("Browse stores")}</Link>
      </div>
    </div>
  );
}

export function Drops() { const lang = useLang();
  const { t } = useApp();
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/drops").then((r) => setD(r.data)); }, [lang]);
  return (
    <div className="mv-container" data-testid="drops-page">
      <PageHead eyebrow="MIVO" title={t("drops.title")} />
      {tx(d && d.length === 0 && <div className="rounded-2xl border border-dashed border-[var(--mv-border-2)] p-12 text-[var(--mv-muted)]" data-testid="drops-empty">{t("drops.empty")}</div>)}
    </div>
  );
}

const INFO = {
  orbit: ["MIVO Orbit", "Large multi-angle galleries are live today on every product page. Interactive 3D model viewing will be enabled once 3D assets are uploaded for a product."],
  moments: ["MIVO Moments", "Lifestyle imagery in each collection shows products in real settings. Customer photo moments arrive with verified photo reviews in a later phase."],
  mood: ["MIVO Mood", "Collections curated by mood and lighting. Browse Living, Workspace and Wellness to find your setting."],
  space: ["See it in your space", "Augmented-reality preview is not available yet. It will only be enabled when a supported AR integration and product models are in place."],
  secure: ["Secure checkout", "Checkout uses your MIVO USDT card. USDT payments open once on-chain verification is live — no funds are taken before then."],
  sell: ["Sell on MIVO", "Store creation is managed by the MIVO Super Admin. Seller onboarding and the seller dashboard arrive in an upcoming phase."],
};

export function Experience() { useLang();
  const { slug } = useParams();
  const [title, body] = INFO[slug] || ["MIVO", "This feature is not available yet."];
  return (
    <div className="mv-container max-w-3xl" data-testid={`experience-page-${slug}`}>
      <PageHead eyebrow={tx("MIVO EXPERIENCE")} title={title} />
      <p className="text-[15px] leading-relaxed text-[var(--mv-muted)]">{tx(body)}</p>
      <Link to="/shop" className="mt-8 inline-block mv-btn-primary rounded-lg px-6 py-3 text-sm">{tx("Shop now")}</Link>
    </div>
  );
}

export function Help() { useLang();
  const faqs = [
    ["Do I need an account?", "Browsing and text search are open to everyone. Saving favorites, using the cart and photo search require a free MIVO account."],
    ["Which currency am I charged in?", "Orders settle in USD. CNY and EUR are display conversions using reference rates."],
    ["Who ships my order?", "Each store on MIVO handles its own fulfillment, shipping and returns policy."],
    ["How do I reach support?", "Live AI and human support chat opens in an upcoming phase. Signed-in buyers will see their order context there."],
  ];
  return (
    <div className="mv-container max-w-3xl" data-testid="help-page">
      <PageHead eyebrow={tx("MIVO SUPPORT")} title={tx("Help center")} />
      <div className="space-y-4">
        {faqs.map(([q, a]) => (
          <div key={q} className="rounded-2xl border border-[var(--mv-border)] bg-[var(--mv-card)] p-5"><p className="font-semibold">{tx(q)}</p><p className="mt-2 text-sm text-[var(--mv-muted)]">{tx(a)}</p></div>
        ))}
      </div>
    </div>
  );
}
